import { render, staticRenderFns } from "./miscMtgEditedItem.vue?vue&type=template&id=48f17472&scoped=true&"
import script from "./miscMtgEditedItem.vue?vue&type=script&lang=js&"
export * from "./miscMtgEditedItem.vue?vue&type=script&lang=js&"
import style0 from "./miscMtgEditedItem.vue?vue&type=style&index=0&id=48f17472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f17472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
